module.exports = __webpack_public_path__ + "img/UNICEF-Philippines.dd6436e7.png";